import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  createQuestionRoutine, updateQuestionRoutine, deleteQuestionRoutine
} from '../../routines';
import { createQuestion, updateQuestion, deleteQuestion } from '../../../../services/questionService';
import { successToast, errorToast } from '../../../../common/helpers/toastrHelper';

function* createQuestionReq({ payload }: Routine<any>) {
  try {
    const data = yield call(createQuestion, payload);
    yield put(createQuestionRoutine.success(data));
    yield call(successToast, 'Custom question added to question bank', 'toast.freeResponseQuestionSuccess');
  } catch (error) {
    yield put(createQuestionRoutine.failure(error.message));
    yield call(errorToast, error.message);
  }
}

function* watchCreateQuestionReq() {
  yield takeEvery(createQuestionRoutine.TRIGGER, createQuestionReq);
}

function* updateQuestionReq({ payload }: Routine<any>) {
  try {
    const data = yield call(updateQuestion, payload);
    yield put(updateQuestionRoutine.success(data));
  } catch (error) {
    yield put(updateQuestionRoutine.failure(error.message));
  }
}

function* watchUpdateQuestionReq() {
  yield takeEvery(updateQuestionRoutine.TRIGGER, updateQuestionReq);
}

function* deleteQuestionReq({ payload }: Routine<any>) {
  try {
    yield call(deleteQuestion, payload);
    yield put(deleteQuestionRoutine.success(payload));
  } catch (error) {
    yield put(deleteQuestionRoutine.failure(error.message));
  }
}

function* watchDeleteQuestionReq() {
  yield takeEvery(deleteQuestionRoutine.TRIGGER, deleteQuestionReq);
}

export default function* freeResponseSaga() {
  yield all([
    watchCreateQuestionReq(),
    watchUpdateQuestionReq(),
    watchDeleteQuestionReq()
  ]);
}
